export const currentProject = ({ project }) => project.currentProject;
export const slides = ({ illustration }) => illustration.slides;
export const currentSlide = ({ illustration }) => illustration.currentSlide;
export const notifications = ({ user }) => user.notifications;
